import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CustomContainer } from "../../StyledComponent/StyledComponent";

const AboutMeDetails = () => {
  return (
    <CustomContainer>
      <Container>
        <div>
          <div className="d-flex justify-content-end align-items-center mb-5">
            <Link to="/" className="px-5 bg-light d-inline text-dark">
              <div title="Go Home">
                <FontAwesomeIcon icon={faLongArrowAltRight} size="2x" />
              </div>
            </Link>
          </div>
          <div>
            <h4 className="fw-bold mb-4" style={{ color: "#f7f7f7" }}>
              About me
            </h4>
            <p className="text-light">
              My name is Md Pervej Hossain, I have completed Diploma Engineering
              in Mechanical Technology. But I enjoy more myself when I am
              coding. At firs, I start querying how to pursue and luckily
              reached a bootcamp course door. Where I have learned Web
              Development with the guideline of Jhankar Mahbub (Founder of
              Programming-hero).
              <br />
              <br />I started my journey with a company called TunicaLabs Media
              Pvt Ltd (Thane India). It's an remote internship job which I
              started since May 2022. There I colloborate in a team which was
              allocated to build an Australin project that is JamesHaride.
            </p>
          </div>

          <div className="mt-5">
            <h4 className="fw-bold" style={{ color: "#f7f7f7" }}>
              Industrial Exprience
            </h4>
            <div style={{ color: "#f7f7f7" }}>
              <h6 className="mb-0">Frontend Developer (Intern)</h6>
              <span>Tunicalabs Media Pvt Ltd.</span>
              <ul className="mt-2">
                <li>
                  An opportunity to learn how the technical terms utilize in
                  industrial way. I worked with front-end team whose were
                  building a project (James Hardie) based on NextJs.
                </li>
                <li>
                  We remotely gathered and the team was so friendly there that I
                  collaborated plenty lines of code in the project under my
                  senior’s surveillance.
                </li>
                <li>
                  The daily task was written on Jira Board, I specifically
                  assisted to build new components, pages and fixed uprising
                  bugs in website UI/UX.
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-5">
            <h4 className="fw-bold mb-4" style={{ color: "#f7f7f7" }}>
              Education
            </h4>
            <div style={{ color: "#f7f7f7" }}>
              <h6>
                <span className="fw-bold">Institute:</span>&nbsp; National
                Professional Institute (NPI)
              </h6>
              <h6>
                <span className="fw-bold">Degree:</span>&nbsp; Diploma
                Engineering
              </h6>
              <h6>
                <span className="fw-bold">Department:</span>&nbsp;Mechanical
                Technology
              </h6>
              <h6>
                <span className="fw-bold"> Course Duration:</span>&nbsp; 4 year
                or 8 semester
              </h6>
              <h6>
                <span className="fw-bold"> Passing Year:</span>&nbsp; 2022
              </h6>
            </div>
          </div>
          <div>
            <h4 className="fw-bold mb-3 mt-4" style={{ color: "#f7f7f7" }}>
              Other Activities
            </h4>
            <div style={{ color: "#f7f7f7" }}>
              <li>
                Compleated Web Development course in 2021 with Jhankar Mahbub.
              </li>
              <li>
                Compleated Responsive Web Design 2020 in Coder Trust Bangladesh.
              </li>
              <li>
                Achived 6<sup>th</sup> position in Speech Compition in 2022
                under Bangladesh Technical Education Board (BTEB).
              </li>
            </div>
          </div>
        </div>
      </Container>
    </CustomContainer>
  );
};

export default AboutMeDetails;
